<template>
  <section>
    <gs-header title="Quản lý đối soát">
      <el-button type="primary" size="small" @click="isOpenDialogCompare = true" icon="el-icon-plus">Thêm mới đối soát</el-button>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="crossCheckTable" :table-name="crossCheckTable" data-source="cross-checks" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="block">
                <el-date-picker size="small" class="width-100" v-model="filterDateRange" type="daterange" range-separator="/"
                  @input="updateFilters" format="dd-MM-yyyy" start-placeholder="Từ ngày"
                  end-placeholder="Đến ngày">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6">
              <el-select size="small" class="display-block" v-model="filters.kind" filterable clearable placeholder="Kiểu đối soát"
                @change="filter">
                <el-option v-for="(kindName, kindKey) in crossChecksHelpers.kinds" :key="kindKey" :label="kindName"
                  :value="kindKey">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-radio-group class="status-listting" v-model="filters.status" v-if="crossChecksHelpers.statuses"
                @change="filter">
                <el-radio-button :label="index" v-for="(status, index) in crossChecksHelpers.statuses" :key="index">
                  {{ status }}
                </el-radio-button>
                <el-radio-button :label="-1">
                  <span>Tất cả</span>
                </el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border style="width: 100%">
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[crossCheckTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[crossCheckTable].current_page - 1) *
                    dataPaginations[crossCheckTable].per_page)
                }}</small>
              </template>
            </el-table-column>

            <el-table-column label="Đối Soát" width="200">
              <template slot-scope="scope">
                <p v-if="scope.row.id"><span class="shipment-code-display click-copy">{{ scope.row.id }}</span></p>
                <p>
                  <el-tooltip placement="top" content="Ngày tạo" class="display-inline">
                    <span>{{ scope.row.created_at }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin">
              <template slot-scope="scope">
                <div class="text-grey">
                  <p><span>Ngày đối soát:</span> {{ scope.row.created_at }}</p>
                  <p><span>Kiểu đối soát:</span> <el-tag size="small" :type="kindStatus(scope.row.kind)">{{ scope.row.kind_txt }}</el-tag></p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Ghi chú">
              <template slot-scope="scope">
                <div class="text-grey">
                  <p v-if="scope.row.note">{{ scope.row.note }}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Đơn Hàng">
              <template slot-scope="scope">
                <div class="text-grey">
                  <p><span>Thành công:</span> <span class="text-green">{{ scope.row.num_compare_success }}</span></p>
                  <p><span>Lỗi:</span> <span class="text-orange">{{ scope.row.num_compare_error }}</span></p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Tổng COD thu">
              <template slot-scope="scope">
                <div class="text-grey">
                  <p><span class="text-red">{{ scope.row.cod_carrier | vnd }}</span></p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Trạng Thái">
              <template slot-scope="scope">
                <div>
                  <p><span :class="compareStatuses[scope.row.status]">{{ scope.row.status_txt }}</span></p>
                </div>
              </template>
            </el-table-column>

            <el-table-column width="110" label="Thao Tác" align="center">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Chi tiết đối soát" class="display-inline">
                    <router-link class="text-grey padding-all display-inline-block"
                      :to="{ name: 'listting-compare', params: { id: scope.row.id } }"><i
                        class="el-icon-view"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xác nhận đối soát" class="display-inline" v-if="!scope.row.status">
                    <el-button type="text" @click.prevent="confirmApplyCompare(scope.row)"
                      icon="el-icon-check"></el-button>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xuất bảng kê" class="display-inline">
                    <el-button type="text" @click.prevent="exportExcelComapre(scope.row)"
                      icon="el-icon-download"></el-button>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa ghi chú đối soát" class="display-inline">
                    <el-button type="text" @click.prevent="editNoteCompare(scope.row)"><i
                        class="el-icon-edit"></i></el-button>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Hủy đối soát" class="display-inline" v-if="!scope.row.status">
                    <el-button type="text" @click.prevent="removeCompare(scope.row)"><i
                        class="el-icon-remove text-red"></i></el-button>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
    <el-dialog :visible.sync="isOpenDialogCompare" title="Tạo đối soát" width="500px">
      <div class="padding-sm-bottom">
        <span>Bạn chắc chắn muốn tạo mới đối soát loại nào</span>
        <el-radio-group v-model="kindCrossCheck" size="small" style="margin-left: 5px;">
          <el-radio-button :label="1">Cod</el-radio-button>
          <el-radio-button :label="4">Phí</el-radio-button>
          <el-radio-button :label="2">Phí lần 2</el-radio-button>
        </el-radio-group>
      </div>
      <h4 class="margin-bottom margin-top">Ghi chú</h4>
      <el-input type="textarea" :rows="3" v-model="note" placeholder="Nhập ghi chú" maxlength="255" show-word-limit></el-input>
      <template v-if="kindCrossCheck !== 1">
        <h4 class="margin-bottom margin-top">Tháng đối soát</h4>
        <el-date-picker
        class="width-100"
          v-model="monthRangeVal"
          type="month"
          placeholder="Chọn tháng">
        </el-date-picker>
      </template>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="isOpenDialogCompare = false">Thoát</el-button>
          <el-button type="primary" @click="importNewCompare()">
            Tạo mới
          </el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog :visible.sync="isOpenDialogEditNote" title="Sửa ghi chú đối soát" width="500px">
      <h4 class="margin-bottom margin-top">Ghi chú</h4>
      <el-input type="textarea" :rows="3" v-model="noteEdit" placeholder="Nhập ghi chú" maxlength="255" show-word-limit></el-input>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="isOpenDialogEditNote = false">Thoát</el-button>
          <el-button type="primary" @click="handlerEditNote()">
            Xác nhận
          </el-button>
        </div>
      </template>
    </el-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { debounce, head, keys, forEach } from 'lodash'
import ls from 'local-storage'
import { createCrossCheck, DeleteCrossCheck, ApplyCrossCheck, UpdateCrossCheck } from 'src/api/compares'
import { formatDate } from 'src/helpers'
import { compareStatuses, compareStatusesBg } from 'src/stubs/compares'
import moment from 'moment'
import { exportCodListing, exportCompareFeeListing} from 'src/api/invoice'

const CROSS_CHECK_TYPES = {
  COD: {
    kind: 1,
    exportFunction: exportCodListing,
    fileNamePrefix: 'COD'
  },
  FEE_COMPARE: {
    kind: 2,
    exportFunction: exportCompareFeeListing,
    fileNamePrefix: 'Phí Lần 2'
  }
}

export default {
  name: 'Compare',
  data() {
    return {
      crossCheckTable: 'crossChecks',
      updateCrossCheck: false,
      filters: {
        status: -1,
        carrier_id: '',
        include: '',
        sort: 'created_at:-1',
        start_date: '',
        end_date: '',
        kind: ''
      },
      sorted: {
        created_at: -1,
        started_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' },
        { key: 'started_at', name: 'Ngày đối soát' }
      ],
      filterDateRange: '',
      compareStatuses: compareStatuses,
      compareStatusesBg: compareStatusesBg,
      createModal: false,
      currentCompare: {},
      isOpenDialogCompare: false,
      kindCrossCheck: 1,
      monthRangeVal: '',
      note: '',
      noteEdit: '',
      isOpenDialogEditNote: false,
    }
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        this.filters = { ...this.filters, ...newQuery }
        if (this.filters.start_date && this.filters.end_date) {
          this.filterDateRange = [
            this.filters.start_date,
            this.filters.end_date,
          ]
        }
        ['status'].forEach((key) => {
          if (this.filters[key]) {
            this.filters[key] = Number(this.filters[key])
          }
        })
      },
      deep: true, // Theo dõi sâu các thay đổi bên trong đối tượng query (nếu cần)
      immediate: true, // Gọi handler ngay khi component được tạo (lần đầu tiên)
    },
  },
  computed: {
    // ...mapGetters('carrier', ['carriers']),
    ...mapGetters('compare', ['crossChecksHelpers'])
  },
  methods: {
    // ...mapActions('carrier', ['getAllCarriers']),
    ...mapActions('compare', ['getCrossChecksHeppers']),
    removeFilter() {
      if (!this.checkDefaultFilter({
        status: -1,
        carrier_id: '',
        include: 'carrier',
        sort: 'created_at:-1',
        start_date: '',
        end_date: '',
        kind: ''
      })) {
        this.reloadGsTable(this.crossCheckTable)
      }
      this.filterDateRange = ''
      this.filters = {
        status: -1,
        carrier_id: '',
        include: 'carrier',
        sort: 'created_at:-1',
        start_date: '',
        end_date: '',
        kind: ''
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.crossCheckTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.crossCheckTable)
      }
      this.$router.push({ query: this.filters })
    }, 300),
    updateFilters(data) {
      const startDate = data ? formatDate(data[0]) : null
      const endDate = data ? formatDate(data[1]) : null

      this.filters.start_date = startDate
      this.filters.end_date = endDate
      this.filter()
    },
    importNewCompare() {
      // this.createModal = true
      // this.localCrossCheck = {}
    this.toggleLoadding(true)
    createCrossCheck({kind: this.kindCrossCheck, note: this.note, month: this.kindCrossCheck === 1 ? undefined : this.monthRangeVal}).then(response => {
      switch (response.code) {
        case 200:
          this.$message({
            type: 'success',
            message: 'Thêm đối soát thành công'
          })
          this.reloadGsTable(this.crossCheckTable)
          this.toggleLoadding(false)
          this.isOpenDialogCompare = false
          break
        case 422:
          let er = response.data.errors
          let message = head(er[Object.keys(er)[0]])
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            body: message,
            type: 'warning'
          })
          this.toggleLoadding(false)
          this.isOpenDialogCompare = false
          break
        default:
          this.$message({
            type: 'error',
            message: 'Thêm đối soát thất bại vui lòng kiểm tra lại thông tin'
          })
          this.toggleLoadding(false)
          this.isOpenDialogCompare = false
        }
      })
    },
    validateBeforeSubmitCrossCheck() {
      this.$refs.createCrossCheckForm.validate(valid => {
        if (valid) {
          createCrossCheck(this.localCrossCheck).then(response => {
            switch (response.code) {
              case 200:
                this.$message({
                  type: 'success',
                  message: 'Thêm đối soát thành công'
                })
                this.shieldModal = false
                this.reloadGsTable(this.crossCheckTable)
                this.toggleLoadding(false)
                break
              case 422:
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.$message({
                  type: 'error',
                  message: 'Thêm đối soát thất bại vui lòng kiểm tra lại thông tin'
                })
                this.toggleLoadding(false)
            }
          })
        }
      })
    },
    removeCompare(compare) {
      this.currentCompare = compare
      this.$confirm(`Bạn chắc chắn muốn xóa phiên đối xoát ${this.currentCompare.id}`, 'Xóa phiên đối xoát', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delCompare()
      }).catch(() => {

      })
    },
    confirmApplyCompare(compare) {
      this.currentCompare = compare
      this.$confirm(`Bạn chắc chắn muốn xác nhận phiên đối xoát ${this.currentCompare.id}`, 'Xác nhận đối xoát', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.applyCompare()
      }).catch(() => {

      })
    },
    delCompare() {
      DeleteCrossCheck(this.currentCompare.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Hủy đối soát thành công.'
          })
          this.reloadGsTable(this.crossCheckTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Hủy đối soát thất bại'
          })
        }
      })
    },
    applyCompare() {
      this.toggleLoadding(true)
      ApplyCrossCheck(this.currentCompare.id).then(response => {
        if (response.code === 200) {
          this.toggleLoadding(false)
          this.$message({
            type: 'success',
            message: 'Xác nhận đối soát thành công.'
          })
          this.reloadGsTable(this.crossCheckTable)
        } else {
          this.toggleLoadding(false)
          this.$store.dispatch('showNotify', {
            title: 'Xác nhận đối soát',
            body: response.data.message ? response.data.message : 'Xác nhận đối soát thất bại!',
            type: 'warning'
          })
        }
      })
    },
    kindStatus(kind) {
      switch (kind) {
        case 1:
          return 'success'
        case 2:
          return 'danger'
        default:
          return 'info'
      }
    },
    exportExcelComapre(crossCheck) {
      const type = Object.values(CROSS_CHECK_TYPES).find(t => t.kind === crossCheck.kind);
      if (!type) {
        return;
      }
      const handleExport = async () => {
        try {
          this.submitting = true;
          const response = await type.exportFunction({ crossCheckId: crossCheck.real_id });

          switch (response.status) {
            case 200:
              this.saveBlobToFile(response.data, crossCheck.created_at, type.fileNamePrefix);
              break;
            case 400:
              this.$store.dispatch('showNotify', {
                title: 'Vui lòng thử lại sau ít phút',
                type: 'error'
              });
              break;
            default:
              this.$store.dispatch('showNotify', {
                title: response.data.message || 'Có lỗi xảy ra',
                type: 'error'
              });
          }
        } catch (err) {
          const title = err.message.includes('status code 400')
            ? 'Vui lòng thử lại sau ít phút'
            : err.message;
          this.$store.dispatch('showNotify', {
            title,
            type: 'error'
          });
        } finally {
          this.submitting = false;
        }
      };

      handleExport();
    },
    saveBlobToFile(blob, date, shortName) {
      // Tạo URL từ Blob
      const url = URL.createObjectURL(blob);

      // Tạo một thẻ <a> để kích hoạt việc tải file
      const link = document.createElement('a');
      link.href = url;
      link.download = `Bảng kê ${shortName} ${date}`;  // Tên file sẽ tải xuống

      // Kích hoạt tải file
      link.click();

      // Giải phóng URL sau khi tải xong
      URL.revokeObjectURL(url);
    },
    editNoteCompare(compare) {
      this.currentCompare = compare
      this.isOpenDialogEditNote = true
      this.noteEdit = this.currentCompare.note
    },
    handlerEditNote() {
      UpdateCrossCheck(this.currentCompare.id, {note: this.noteEdit}).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Cập nhật ghi chú thành công.'
          })
          this.reloadGsTable(this.crossCheckTable)
          this.toggleLoadding(false)
          this.isOpenDialogEditNote = false
        } else {
          this.toggleLoadding(false)
          this.$message({
            type: 'error',
            message: 'Cập nhật ghi chú thất bại'
          })
        }
      })
    },
  },
  mounted() {
    this.clickToCopy()
    this.monthRangeVal = moment().format('YYYY-MM')
    if (ls.get('filters') && ls.get('filters')[this.crossCheckTable]) {
      this.filters = ls.get('filters')[this.crossCheckTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    if (!Object.keys(this.crossChecksHelpers).length) {
      this.getCrossChecksHeppers()
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.crossCheckTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['crossChecks']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>



// WEBPACK FOOTER //
// Compare.vue?6b1d9ed9